<template>
  <div class="dialog">
    <el-dialog
      title="推送提醒"
      @close="closeView"
      :visible.sync="pushViewbtns"
      width="35%"
      :modal-append-to-body="false"
    >
      <div class="pushBody">
        <div class="pushTips">续费提醒将通过微信公众号形式，发送给学员。</div>
        <div class="pushinfo">
          <div class="pushHead">接收人：</div>
          <div class="infodata list">
            <div>
              <span>
                {{ target.name || target.student.name }}
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="pushinfo">
          <div class="pushHead">推送内容：</div>
          <div class="infodata">
            <div>您的课时即将消耗完毕，请尽快续费~</div>
            <div>学员名称：-</div>
            <div>剩余课时：-</div>
            <div>如有疑问请联系门店工作人员。</div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="mwow-button-filled mini" @click="closeView">取消</div>
        <div class="mwow-button-filled mini success" @click="pushClick">
          推送
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { renewPush } from "@/api/renewal";
export default {
  props: ["target", "targetName"],
  data() {
    return {
      pushViewbtns: true,
    };
  },
  methods: {
    pushClick() {
      if (this.target.list) {
        // 推送学员所有课程
        renewPush({ student_id: this.target.student_id }).then((res) => {
          if (res.error_code === 0) {
            this.$message({
              type: "success",
              message: "推送成功!",
            });
            this.$emit("closeView", "push");
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        // 推送单课程
        renewPush({ student_course_account_id: this.target.account_id }).then(
          (res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "推送成功!",
              });
              this.$emit("closeView", "push");
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          }
        );
      }
    },
    closeView() {
      this.$emit("closeView", "close");
    },
  },
};
</script>

<style scoped lang="scss">
.pushTips {
  color: #9e9fa0;
  font-size: 12px;
}
.pushinfo {
  display: flex;
  margin-top: 14px;
  .pushHead {
    color: #5c5d5e;
    font-size: 12px;
    font-weight: 500;
    width: 70px;
  }
  .infodata {
    color: #5c5d5e;
    font-size: 12px;
    div {
      margin-bottom: 5px;
    }
  }
  .infodata.list {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
